<content>
    <section class="entry-inline-framed">
        <label>{{'mantenimiento-etiquetas.formato.grupoEtiqueta' | translate}}</label> {{grupoEtiquetaId}} - {{desGrupoEtiqueta}}
    </section>
    <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="long">{{'mantenimiento-etiquetas.formato.id' | translate}}</th>
                        <th class="long">{{'mantenimiento-etiquetas.formato.nombreFormato' | translate}}</th>
                        <th class="long">{{'mantenimiento-etiquetas.formato.configuracion' | translate}}</th>
                        <th>{{'mantenimiento-etiquetas.formato.fechaUpd' | translate}}</th>
                        <th class="action">
                            <i class="fas fa-plus" (click)="newFormatoEtiqueta()" app-click-stop-propagation title="{{'mantenimiento-etiquetas.formato.tituloNew' | translate}}"></i>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <app-fetq-new-edit class="component-in-row" *ngIf="new" [editable]="true" (close)="new=$event" [configuraciones]="configuraciones" (close)="new=$event"
                        [grupoEtiquetaId]="grupoEtiquetaId" (refresh)="toRefresh($event)" (pushMessage)="showMessages($event)">
                    </app-fetq-new-edit>
                    <app-fetq-new-edit class="component-in-row" *ngFor="let formatoEtiqueta of formatosAsociados" (editableChanged)="editableChanged($event)"
                        [editable]="formatoEtiqueta === editables" [formatoEtiqueta]="formatoEtiqueta" [configuraciones]="configuraciones"
                        [grupoEtiquetaId]="grupoEtiquetaId" (refresh)="toRefresh($event)" (pushMessage)="showMessages($event)">
                    </app-fetq-new-edit>
                </tbody>
            </table>
        </div>
    </div>
    <app-paginator *ngIf="formatosAsociados && formatosAsociados.length > 0" [itemsPerPage]="itemsPerPage"
        [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages" [hiddeItems]="true"
        (pageChange)="pageChange($event)"></app-paginator>
</content>
<app-toast *ngIf="(showError) && mensajes" [messages]="mensajes" (closed)="showError=$event">
</app-toast>
<footer class="button-bar-right">
    <button (click)="close()">{{'global.aceptar' | translate}}</button>
</footer>
